@if (!multiple()) {
  <app-dropdown-input
    [options]="options()"
    optionUniqKey="id"
    [value]="dropdownValue()"
    [placeholder]="placeholder()"
    [appearance]="appearance()"
    [size]="size()"
    [disabled]="disabled()"
    [icon]="render() === 'icon' || render() === 'icon-text' ? 'sapphire-calendars' : undefined"
    [iconOnly]="render() === 'icon'"
    [withClear]="clear()"
    placement="bottomRight"
    (onChange)="handleSingleSelect($event)"
  />
} @else {
  <app-dropdown-input
    [options]="options()"
    [placeholder]="multipleDisplayText() || placeholder()"
    [appearance]="appearance()"
    [size]="size()"
    [disabled]="disabled()"
    [icon]="render() === 'icon' || render() === 'icon-text' ? 'sapphire-calendars' : undefined"
    [iconOnly]="render() === 'icon'"
    [withClear]="clear()"
    [itemTemplate]="multiItemTemplate"
    placement="bottomRight"
  />

  <ng-template #multiItemTemplate let-item="item" let-title="title">
    <div class="max-w-3xs">
      <app-checkbox2
        [label]="title"
        [checked]="isSelected(item.id)"
        [color]="item.color"
        class="p-2 text-nowrap hover:bg-hover rounded"
        (checkedChange)="handleMultiToggle(item, $event)"
        (click)="$event.stopPropagation()"
      />
    </div>
  </ng-template>
}
